import React, { Component } from 'react'

import {
  Container,
  ArticlesCount,
  ArticlesWrapper,
  MediaHousesWrapper,
  ArticlesText,
  MediaHousesCount,
  MediaHousesText
} from './styledComponents'

export default class StatsContainer extends Component {
  render() {
    const {
      articlesCount,
      articlesText,
      mediaHousesCount,
      mediaHousesText
    } = this.props.statsData[0]
    return (
      <Container>
        <ArticlesWrapper>
          <ArticlesCount as="p">{articlesCount}</ArticlesCount>
          <ArticlesText>{articlesText}</ArticlesText>
        </ArticlesWrapper>
        <MediaHousesWrapper>
          <MediaHousesCount>{mediaHousesCount}</MediaHousesCount>
          <MediaHousesText>{mediaHousesText}</MediaHousesText>
        </MediaHousesWrapper>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/IbcNews/StatsContainer/index.js